import { MailFolderTableQuery, TableQuery, TableQueryType } from 'owa-mail-list-store';
import { SearchTableQuery } from 'owa-mail-list-search';

export default function getTableId(tableQuery: TableQuery): string {
    const tableId = [];
    switch (tableQuery.type) {
        case TableQueryType.Folder:
            tableId.push('folderId:' + tableQuery.folderId);

            const mailTableQuery = tableQuery as MailFolderTableQuery;
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('viewFilter:' + mailTableQuery.viewFilter);
            tableId.push('focusedViewFilter:' + mailTableQuery.focusedViewFilter);
            tableId.push('inboxClassificationFilter: ' + mailTableQuery.inboxClassificationFilter);
            tableId.push('sortColumn:' + mailTableQuery.sortBy.sortColumn);
            tableId.push('sortDirection:' + mailTableQuery.sortBy.sortDirection);

            if (mailTableQuery.categoryName) {
                tableId.push('catName:' + mailTableQuery.categoryName);
            }
            break;

        case TableQueryType.Search:
            tableId.push('folderId:' + tableQuery.folderId);

            const searchTableQuery = tableQuery as SearchTableQuery;
            tableId.push('id:' + searchTableQuery.searchNumber);
            tableId.push('query:' + searchTableQuery.queryString);
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('scenarioType:' + searchTableQuery.scenarioType);
            break;

        case TableQueryType.Group:
            tableId.push('groupId:' + tableQuery.folderId);

            const groupMailTableQuery = tableQuery as MailFolderTableQuery;
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('viewFilter:' + groupMailTableQuery.viewFilter);
            break;
    }

    return tableId.join(';').toString();
}
